import { DocumentType } from '@nemuru-eng/js-api-client';

export const NIE_DOCUMENT_TYPES: DocumentType[] = [DocumentType.NIE_EU, DocumentType.NIE_NON_EU];
